"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cloudinaryImageUrl = exports.getImageHeight = exports.ratioOptions = exports.bgMode = exports.URL_EXCLUDE = exports.URL_PREFIX = exports.CLOUDINARY_URL = void 0;

/* eslint-disable no-magic-numbers */
var CLOUDINARY_URL = 'https://res.cloudinary.com';
exports.CLOUDINARY_URL = CLOUDINARY_URL;
var URL_PREFIX = "".concat(CLOUDINARY_URL, "/scentre-group-au/image/fetch/");
exports.URL_PREFIX = URL_PREFIX;
var URL_EXCLUDE = [CLOUDINARY_URL, '/static', '/_next'];
exports.URL_EXCLUDE = URL_EXCLUDE;
var bgMode = {
  cover: 'c_fill,q_auto,g_faces:auto',
  contain: 'c_pad,b_auto',
  stretch: ''
};
exports.bgMode = bgMode;
var ratios = {
  square: 1,
  standard: Number(2 / 3),
  poster: Number(3 / 2),
  feature: Number(9 / 21)
};
var ratioOptions = Object.keys(ratios);
exports.ratioOptions = ratioOptions;

var calcContainerWidth = function calcContainerWidth(_ref) {
  var type = _ref.type,
      ratio = _ref.ratio;

  // get special images widths for mobile and features
  if (type === 'mobile') {
    return 640;
  }

  if (ratio === 'feature') {
    return 2500;
  }

  return 18 * 4 * 16;
};

var getRatioWidthHeight = function getRatioWidthHeight(type, ratio, numberOfItems, minWidth) {
  var containerWidth = calcContainerWidth({
    type: type,
    ratio: ratio
  });
  var imageRatio = ratios[ratio] || ratios.standard;
  var width = Math.floor(containerWidth / numberOfItems);
  width = minWidth ? Math.max(width, minWidth) : width;
  var height = Math.floor(width * imageRatio);
  return {
    width: width,
    height: height
  };
};

var getImageHeight = function getImageHeight(_ref2) {
  var type = _ref2.type,
      ratio = _ref2.ratio,
      numberOfItems = _ref2.numberOfItems;
  var height = 0;

  if (type || ratio) {
    height = getRatioWidthHeight(type, ratio, numberOfItems).height;
  }

  return height;
};

exports.getImageHeight = getImageHeight;

var cloudinaryImageUrl = function cloudinaryImageUrl(_ref3) {
  var src = _ref3.src,
      type = _ref3.type,
      ratio = _ref3.ratio,
      _ref3$numberOfItems = _ref3.numberOfItems,
      numberOfItems = _ref3$numberOfItems === void 0 ? 1 : _ref3$numberOfItems,
      bgSize = _ref3.bgSize,
      _ref3$minWidth = _ref3.minWidth,
      minWidth = _ref3$minWidth === void 0 ? 600 : _ref3$minWidth,
      width = _ref3.width,
      _ref3$autoFormat = _ref3.autoFormat,
      autoFormat = _ref3$autoFormat === void 0 ? true : _ref3$autoFormat;

  if (!src || URL_EXCLUDE.some(function (val) {
    return src.startsWith(val);
  })) {
    return src;
  } else {
    var url = src;
    var cropOptions = [bgMode[bgSize] || bgMode.cover];

    if (width) {
      cropOptions.push("w_".concat(width));
    } else if (type || ratio) {
      var size = getRatioWidthHeight(type, ratio, numberOfItems, minWidth);
      cropOptions.push("w_".concat(size.width, ",h_").concat(size.height));
    }

    if (autoFormat) {
      cropOptions.push('f_auto');
    }

    if (src.indexOf('//') === 0) {
      url = "https:".concat(src);
    }

    return "".concat(URL_PREFIX).concat(cropOptions.join(','), "/").concat(url);
  }
};

exports.cloudinaryImageUrl = cloudinaryImageUrl;
var _default = cloudinaryImageUrl;
exports.default = _default;